import { render, staticRenderFns } from "./ReportCustomerAttendanceProtocol.vue?vue&type=template&id=6171f7a6"
import script from "./ReportCustomerAttendanceProtocol.vue?vue&type=script&lang=js"
export * from "./ReportCustomerAttendanceProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports